export const educationData = [
  {
    university: "National University of Malaysia (UKM)",
    degree: "Bachelor's Degree",
    major: "Computer Science",
    dates: "2015 - 2018",
    gpa: null,
    honors: ["Popular Appearance Final Year Project Award"]
  },
  {
    university: "Politeknik Tuanku Syed Sirajuddin",
    degree: "Diploma",
    major: "Information Technology (Programming)",
    dates: "2011 - 2014",
    gpa: null,
    honors: []
  },
  {
    university: "SMK Puchong Utama 1",
    degree: "SPM",
    major: "Science ICT",
    dates: "2006 - 2010",
    gpa: null,
    honors: []
  }
];
